





import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';

//@ts-expect-error: is not module
import prism from 'vue-prism-component';
import 'prismjs/components/prism-python.js';
import 'prismjs/components/prism-php.js';
import 'prismjs/components/prism-go.js';
import 'prismjs/components/prism-java.js';
import 'prismjs/components/prism-kotlin.js';
import 'prismjs/components/prism-swift.js';
import 'prismjs/components/prism-php.js';

import { State } from 'vuex-class';
import { computeHighLightNumberHelper } from '@/heplers';
import TransitionExpand from '@/components/ui/TransitionExpand.vue';

@Component({
  components: {
    TransitionExpand,
    prism,
  },
})
export default class Prism extends Vue {
  @Prop({ type: String, default: 'javascript' }) language: string;
  @Prop({ type: Array }) highlight: string[];
  @State pageRendered: boolean;
  computeHighLightNumber = computeHighLightNumberHelper;
  private highLightArray: number[] = [];

  @Watch('pageRendered')
  onPageRendered(isRendered: boolean) {
    if (isRendered) this.initMethods();
  }

  mounted() {
    this.initMethods();
  }

  private initMethods() {
    this.highLightArray = this.computeHighLightNumber(this.highlight);
    this.appendBlurLines(this.$refs.code);
    this.appendLineNumbers(this.$refs.code);
  }

  private appendLineNumbers(env: any) {
    if (!env?.hasChildNodes() || env.querySelector('.line-numbers-rows')) return;

    const code = env.firstChild;
    const match = code.innerText.match(/\n(?!$)/g);
    const linesNum = match ? match.length + 1 : 1;
    const lineNumbersWrapper = document.createElement('span');
    const lines = new Array(linesNum + 1).join('<span></span>');

    lineNumbersWrapper.setAttribute('aria-hidden', 'true');
    lineNumbersWrapper.className = 'line-numbers-rows';
    lineNumbersWrapper.innerHTML = lines;

    code.appendChild(lineNumbersWrapper);
  }

  /**
   * Если у нас есть highLight, то проходимся по коду, и строки которые !highlight мы оборачиваем в тег со специальным классом чтобы заблюрить
   */
  private appendBlurLines(code: any) {
    if (!code?.hasChildNodes() || !this.highLightArray.length) return;

    const codeFirstChild = code.firstChild;

    if (!codeFirstChild.innerText.length) return;

    let newCode = codeFirstChild.innerHTML.match(/.*\n/g);

    newCode = newCode.map((value: string, index: number) => {
      if (!this.highLightArray.includes(index + 1))
        return '<span class="blur">' + value + '</span>';
      else return value;
    });

    code.firstChild.innerHTML = newCode.join('');
  }
}
